import { render } from "./myLikes.vue?vue&type=template&id=d0e3f19a&scoped=true&ts=true"
import script from "./myLikes.vue?vue&type=script&lang=ts"
export * from "./myLikes.vue?vue&type=script&lang=ts"

import "./myLikes.vue?vue&type=style&index=0&id=d0e3f19a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0e3f19a"]])

export default __exports__